import TextField from "@mui/material/TextField";
import React from "react";
import InputAdornment from "@mui/material/InputAdornment";

const CustomTextField = ({
  label,
  isMandatory,
  value,
  onChange,
  type,
  validators,
  errorMessages,
  handleKeyPress,
  handleOnBlur,
  inputTextColor,
  labelTextColor,
  inputPadding,
  placeholder,
  inputRef,
  inputPaddingValue = "5px",
  labelFontSize,
  inputTextFontSize,
  labelTracking,
  height,
  isInputAdornmentAllowed = false,
  Icon,
  borderColor = null, // Default border color
  borderHoverColor = null, // Border color on hover
  borderWidth = null, // Border width
  borderRadius = "8px", // Border radius
  multiline = false,
  internalPadding = false,
  minRows = 1,
  maxRows = 1,
}) => {
  return (
    <TextField
      ref={inputRef}
      label={label}
      name={label}
      id={label}
      placeholder={placeholder}
      validators={validators}
      errorMessages={errorMessages}
      size="small"
      onChange={(e) => onChange(e.target.value)}
      onBlur={handleOnBlur}
      value={value ?? ""}
      inputProps={{
        autoComplete: "new-password",
        form: { autoComplete: "off" },
        name: "random_name_" + Math.random().toString(36).substring(2, 10),
      }}
      autoComplete="off"
      type={type}
      required={isMandatory}
      onKeyDown={handleKeyPress}
      multiline={multiline}
      minRows={minRows}
      maxRows={maxRows}
      InputProps={{
        ...(internalPadding && { style: { padding: "12px" } }), // Internal padding
        ...(isInputAdornmentAllowed && {
          endAdornment: (
            <InputAdornment position="end">
              <div className="bg-primary/10 w-[18px] h-[18px] rounded-[50%] flex justify-center items-center">
                <Icon className="text-primary" />
              </div>
            </InputAdornment>
          ),
        }),
      }}
      sx={{
        width: "100%",
        "& label": {
          color: labelTextColor || "rgb(var(--color-text-muted))",
          fontFamily: "var(--font-body) !important",
          padding: inputPadding ? inputPaddingValue : "",
          fontSize: labelFontSize || "0.75rem",
          letterSpacing: labelTracking || "",
        },
        "& label.Mui-focused": {
          color: "rgb(var(--color-text-placeholder))",
          fontFamily: "var(--font-body) !important",
        },
        "& input": {
          fontFamily: "var(--font-body)",
          fontSize: inputTextFontSize || "0.75rem",
          fontWeight: "400",
          color: inputTextColor || "rgb(var(--color-text-secondary))",
        },
        "& .MuiOutlinedInput-root": {
          "& fieldset": {
            borderColor: borderColor && borderColor,
          },

          borderRadius: borderRadius, // Custom border radius
          padding: inputPadding ? inputPaddingValue : "",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height, // Applied height directly
        },
        "& .MuiInputLabel-root": {
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontFamily: "var(--font-body)",
          color: labelTextColor || "rgb(var(--color-text-muted))",
          fontSize: labelFontSize || "0.75rem",
        },
        "& .MuiInputLabel-shrink": {
          fontSize: "1rem",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          fontFamily: "var(--font-body)",
        },
      }}
    />
  );
};

export default CustomTextField;
